import { HTMLInputTypeAttribute, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { RightAlignedButtons } from '../button/aligned-buttons';
import { BaseButtonProps } from '../button/base-button';
import { LoadingButton } from '../button/loading-button';

interface FormSubmitProps extends BaseButtonProps {
  loading?: boolean;
  disabled?: boolean;
  label?: string;
  placement?: 'center' | 'none';
  type?: HTMLInputTypeAttribute;
}

export const FormSubmitButton = (props: FormSubmitProps): ReactElement => {
  const { i18n } = useTranslation();
  const buttonContent = (
    <>
      <LoadingButton
        loading={props.loading || false}
        buttonId={props.buttonId}
        buttonProps={{
          type: 'submit',
          disabled: props.disabled,
          expand: props.placement === 'center' ? 'block' : undefined,
          ...props.buttonProps,
        }}
      >
        {props.children || props.label || i18n.t('common:update')}
      </LoadingButton>
      <input
        type={props.type ?? 'submit'}
        style={{ display: 'none' }}
        disabled={props.disabled}
      />
    </>
  );

  if (props.placement === 'center') {
    return <div className="ion-padding-horizontal">{buttonContent}</div>;
  } else if (props.placement === 'none') {
    return buttonContent;
  } else {
    return <RightAlignedButtons>{buttonContent}</RightAlignedButtons>;
  }
};
